module.exports = __webpack_public_path__ + "/img/Standoff-Female-Labeled-bEh4mJ.svg";